const BUNDLE_DISCOUNTS = {
  'USD': 19,
  'AUD': 39,
  'GBP': 15.8201,
  'CNY': 141,
  'JPY': 2513.6364,
  'HKD': 156,
  'SGD': 29,
  'EUR': 19.1507,
  'CHF': 18.5701,
  'NOK': 196,
  'SEK': 196,
  'DKK': 136,
}

const BUNDLE_DISCOUNT_TYPE = 'flat';
let DEFAULT_BUNDLE_DISCOUNT = 19

if (window.Shopify?.shop === 'cariuma.myshopify.com') {
  DEFAULT_BUNDLE_DISCOUNT = 19
} else if (window.Shopify?.shop === 'int-cariuma.myshopify.com') {
  DEFAULT_BUNDLE_DISCOUNT = 39
} else if (window.Shopify?.shop === 'cn-cariuma.myshopify.com') {
  DEFAULT_BUNDLE_DISCOUNT = 15.8201
}

const getBundleDiscountAmount = (currency, country = window.Shopify.country) => {
  if (country === 'FI') {
    return 22.5806
  }

  if (currency in BUNDLE_DISCOUNTS) {
    return BUNDLE_DISCOUNTS[currency]
  }

  return DEFAULT_BUNDLE_DISCOUNT
}

export {
  BUNDLE_DISCOUNT_TYPE,
  getBundleDiscountAmount
}